import React, { useEffect, useRef } from 'react'

import { getSubscription } from '@disco/state-management/selectors/subscription'
import { getChargebeeInstance } from '@disco/utils/chargebee'

import { useSelector } from 'hooks/use-redux'

type TokenizeParams = {
  firstName: string
  lastName: string
}
type Tokenize = (params: TokenizeParams) => Promise<void>
type ChargebeeComponent = {
  tokenize: Tokenize
}
export const ChargebeeFormInputs = ({
  chargebeeLoaded,
  onReady,
}: {
  chargebeeLoaded: boolean
  onReady: (chargebeeComponent: ChargebeeComponent) => void
}) => {
  const mountRef = useRef<HTMLDivElement>(null)
  const subscription = useSelector(getSubscription)
  const hasMounted = useRef(false)

  useEffect(() => {
    if (!chargebeeLoaded || hasMounted.current) return

    async function loadChargebeeComponent() {
      const cbInstance = getChargebeeInstance()
      await cbInstance.load('components')

      const component = cbInstance.createComponent('card', {
        currency: subscription.currency_code,
      })
      component.mount(mountRef.current)
      hasMounted.current = true

      onReady(component)
    }

    loadChargebeeComponent()
  }, [chargebeeLoaded, subscription.currency_code, onReady])

  return <div className="ChargebeeCardForm" ref={mountRef} />
}
